var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',_vm._b({attrs:{"type":"number","maxLength":7},on:{"blur":function($event){return _vm.$emit('blur')},"focus":function($event){return _vm.$emit('focus')}},model:{value:(_vm.shadowValue),callback:function ($$v) {_vm.shadowValue=$$v},expression:"shadowValue"}},'Input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }